import React, { useState } from 'react';
import { todayISO } from './dates';

const EntryForm = ({ categories, onAdd, onCancel }) => {
  const [category, setCategory] = useState('');
  const [title, setTitle] = useState('');
  const [subtitle, setSubtitle] = useState('');
  const [occurredOn, setOccurredOn] = useState(todayISO());
  const [busy, setBusy] = useState(false);

  // Falls back to the first category so the submitted value always matches
  // what the select is showing, even if categories arrive after the form opens.
  const chosen = category || categories[0]?.slug || '';

  const submit = async (event) => {
    event.preventDefault();
    if (!title.trim() || !chosen) return;
    setBusy(true);
    try {
      await onAdd({ category: chosen, title, subtitle, occurredOn });
    } finally {
      setBusy(false);
    }
  };

  return (
    <form className="helen-add" onSubmit={submit}>
      <label className="helen-field" htmlFor="helen-title">
        <span>What did you do?</span>
        <input
          id="helen-title"
          value={title}
          placeholder="The Bear, S3"
          onChange={(e) => setTitle(e.target.value)}
        />
      </label>

      <div className="helen-add-row">
        <label className="helen-field" htmlFor="helen-category">
          <span>Kind of thing</span>
          <select
            id="helen-category"
            value={chosen}
            onChange={(e) => setCategory(e.target.value)}
          >
            {categories.map((c) => (
              <option key={c.slug} value={c.slug}>
                {c.emoji} {c.label}
              </option>
            ))}
          </select>
        </label>

        <label className="helen-field" htmlFor="helen-where">
          <span>Where</span>
          <input
            id="helen-where"
            value={subtitle}
            placeholder="on the couch"
            onChange={(e) => setSubtitle(e.target.value)}
          />
        </label>

        <label className="helen-field" htmlFor="helen-when">
          <span>When</span>
          <input
            id="helen-when"
            type="date"
            value={occurredOn}
            onChange={(e) => setOccurredOn(e.target.value)}
          />
        </label>
      </div>

      <div className="helen-rate-actions">
        <button type="submit" className="helen-button is-small" disabled={!title.trim() || !chosen || busy}>
          {busy ? 'Adding' : 'Add it'}
        </button>
        <button type="button" className="helen-linkbutton" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </form>
  );
};

export default EntryForm;
